import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

export const styleProps = {
  size: "text-xxs",
  leading: "leading-4",
  tracking: "tracking-wide",
};

export interface LabelXxsProps extends TextInternalProps {
  "data-testid"?: string;
  textTransform?: string;
}

export const LabelXxs = ({
  color,
  leading,
  truncate,
  weight = "semibold",
  [DATA_TESTID]: dataTestId,
  children,
  textTransform = "uppercase",
}: LabelXxsProps) => {
  const props = {
    ...styleProps,
    color,
    weight: `font-${weight}`,
    leading,
    truncate,
    dataTestId,
    textTransform,
  };

  return (
    <Text_INTERNAL as="span" {...props}>
      {children}
    </Text_INTERNAL>
  );
};
